/** زیرِ فیلدِ شبا: درست/غلط بودنِ رقمِ کنترل و بانکِ صاحبِ شبا — قطعی، نه حدس (v2.160.0). */
import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { checkIban } from "../api/client";

export default function IbanHint({ iban, bank, onBank }) {
  const [r, setR] = useState(null);
  useEffect(() => {
    const v = (iban || "").trim();
    if (v.replace(/\s/g, "").length < 24) { setR(null); return undefined; }
    const t = setTimeout(() => checkIban(v, bank).then((x) => {
      setR(x.data);
      if (x.data?.valid && x.data?.bank && onBank) onBank(x.data.bank);
    }).catch(() => setR(null)), 350);
    return () => clearTimeout(t);
  }, [iban, bank]);   // onBank عمداً نه — هر رندرِ والد تابعِ تازه می‌سازد
  if (!r) return <span>IR + ۲۴ رقم</span>;
  if (!r.valid) return <Typography.Text type="danger">✗ {r.message}</Typography.Text>;
  if (r.mismatch) return <Typography.Text type="warning">⚠ {r.message}</Typography.Text>;
  return <Typography.Text type="success">✓ شبای معتبر — بانک {r.bank || "؟"}</Typography.Text>;
}
